export default __webpack_public_path__ + "static/tabsSectionBg-80a8c8bb25c6c0924be9b2e797d17151.png";